module.exports = __webpack_public_path__ + "static/santanna-3e08c6c966bf3723fb01b0b32600392c.jpeg";